import { render, staticRenderFns } from "./ItemDocuments.vue?vue&type=template&id=380db365&"
import script from "./ItemDocuments.vue?vue&type=script&lang=js&"
export * from "./ItemDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports